/**
 * @generated SignedSource<<eb8cc8a8d96a504f21dc8b37d196c121>>
 * @relayHash 06bc7ae3e2e497941f8d1738171f8bb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5ef6663bccf7015c3707545cb7bee1684c03826006312c2775240be1421634d

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type GlobalOperationsUserPermissionTypeQuery$variables = Record<PropertyKey, never>;
export type GlobalOperationsUserPermissionTypeQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type GlobalOperationsUserPermissionTypeQuery = {
  response: GlobalOperationsUserPermissionTypeQuery$data;
  variables: GlobalOperationsUserPermissionTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionType"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GlobalOperationsUserPermissionTypeQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GlobalOperationsUserPermissionTypeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "06bc7ae3e2e497941f8d1738171f8bb4",
    "id": "f5ef6663bccf7015c3707545cb7bee1684c03826006312c2775240be1421634d",
    "metadata": {},
    "name": "GlobalOperationsUserPermissionTypeQuery",
    "operationKind": "query",
    "text": "query GlobalOperationsUserPermissionTypeQuery{user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
  }
};
})();

(node as any).hash = "b07108af76c48e11bbcd733ba0612fcf";

export default node;
